import { createUseStyles } from 'react-jss';
import '../../../shared/types/colors/index.js';
import { Coverage } from '../../../shared/types/common/index.js';
import { hideScrollbars } from '../../../../foundation/styleHelpers/hideScrollbars/hideScrollbars/index.js';
import { scrollbar } from '../../../../foundation/styleHelpers/scrollbar/scrollbar/index.js';
import { BackgroundColors } from '../../../../foundation/colors/backgroundColors/backgroundColors/index.js';

const useStyles = createUseStyles({
    '@global': {
        html: {
            '&.scroll-frozen': {
                height: '100%',
                overflow: 'hidden',
            },
        },
    },
    root: {
        width: '100%',
        height: '100%',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: ({ zIndex }) => zIndex,
        backgroundColor: BackgroundColors.transparent,
        overflow: 'auto',
        ...scrollbar(),
    },
    hideScrollbars: {
        ...hideScrollbars,
    },
    [Coverage.Global]: {
        position: 'fixed',
    },
    [Coverage.Local]: {
        position: 'absolute',
    },
    table: {
        display: 'table',
        tableLayout: 'fixed',
        width: '100%',
        minHeight: '100%',
    },
    row: {
        display: 'table-row',
    },
    cell: {
        display: 'table-cell',
        verticalAlign: ({ verticalAlign }) => verticalAlign,
        textAlign: ({ horizontalAlign }) => horizontalAlign,
    },
    content: {
        display: 'inline-block',
        verticalAlign: ({ verticalAlign }) => verticalAlign,
        width: ({ contentIsFullWidth }) => contentIsFullWidth && '100%',
        maxWidth: '100%',
        textAlign: 'initial',
    },
}, {
    name: 'overlay',
});

export { useStyles };
